const link_list = {
    routePath: 'edrequests',
    actionName: 'count',
    iconClass: 'fa-solid fa-code-pull-request',
    title: 'Recent Active Ticket',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default {link_list }